import { selectRenew, updateRenew, deviceRenew, deviceScrap } from "../../api/config/modules/EquipmentRenewal";

const state = {
    selectRenew: {},
    updateRenew: {},
    deviceRenew: {},
    deviceScrap: {}
};

const mutations = {
    SET_SELECTRENEW: (state, selectRenew) => {
        state.selectRenew = selectRenew;
    },
    SET_UPDATERENEW: (state, updateRenew) => {
        state.updateRenew = updateRenew;
    },
    SET_DEVICERENEW: (state, deviceRenew) => {
        state.deviceRenew = deviceRenew;
    },
    SET_DEVICESCRAP: (state, deviceScrap) => {
        state.deviceScrap = deviceScrap;
    },
};

const actions = {
    GET_SELECTRENEW: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectRenew(data)
                .then((res) => {
                    commit("SET_SELECTRENEW", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATERENEW: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateRenew(data)
                .then((res) => {
                    commit("SET_UPDATERENEW", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DEVICERENEW: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deviceRenew(data)
                .then((res) => {
                    commit("SET_DEVICERENEW", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DEVICESCRAP: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deviceScrap(data)
                .then((res) => {
                    commit("SET_DEVICESCRAP", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
